/** Items shown under one heading, in the order they were read. */
export type Grouped<T> = {
    title: string;
    items: T[];
};

/**
 * Groups items by the heading each one names, keeping the order they arrive in: a group appears where its
 * first item does, and an item naming a heading already seen joins it instead of opening a second group.
 */
export function groupByTitle<T>(items: T[], titleOf: (item: T) => string): Grouped<T>[] {
    const groups: Grouped<T>[] = [];

    items.forEach((item) => {
        const title = titleOf(item);
        const group = groups.find((candidate) => candidate.title === title);

        if (group) {
            group.items.push(item);
            return;
        }

        groups.push({ title, items: [ item ] });
    });

    return groups;
}
